<template>
	<div>
		<Icon
			:icon-name="icon"
			size="lg"
		/>
	</div>
</template>

<script>
export default {
	name:  'RowSwipeAction',
	props: {
		icon: {
			type: String,
		},
	},
};
</script>

<style scoped>

</style>
